export enum recruitmentsJobsTypes {
  FETCH_RECRUIMENTS_JOBS_REQUEST = "FETCH_RECRUIMENTS_JOBS_REQUEST",
  FETCH_RECRUIMENTS_JOBS_SUCCESS = "FETCH_RECRUIMENTS_JOBS_SUCCESS",
  FETCH_RECRUIMENTS_JOBS_FAILURE = "FETCH_RECRUIMENTS_JOBS_FAILURE",
}